import { useState, useEffect, useCallback } from "react";
import { API, AUTH, toLocalDateStr, fmtMoney, exportXLSX } from "../../adminUtils";
import ExportBar from "./ExportBar";

const STAFF_MAP = {};

export default function PayrollReport() {
  const today = toLocalDateStr(new Date());
  const [from, setFrom]       = useState(() => { const d = new Date(); d.setDate(1); return toLocalDateStr(d); });
  const [to, setTo]           = useState(today);
  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(false);

  const fetch_ = useCallback(async () => {
    setLoading(true);
    try {
      const res  = await fetch(`${API}/reports/payroll?from=${from}&to=${to}`, { headers: AUTH });
      const json = await res.json();
      setData(json);
    } catch { setData(null); }
    finally   { setLoading(false); }
  }, [from, to]);

  useEffect(() => { fetch_(); }, [fetch_]);

  const doExport = () => {
    if (!data?.teachers) return;
    const rows = [];
    for (const t of data.teachers) {
      const rate = STAFF_MAP[t.teacher] ?? 0;
      for (const c of t.classes) {
        rows.push({ Teacher: t.teacher, Date: c.date, Class: c.title,
          Booked: c.booked, Attended: c.attended, Pay: `$${(c.attended * rate).toFixed(2)}` });
      }
      rows.push({ Teacher: t.teacher, Date: "SUBTOTAL",
        Booked: t.classes.reduce((s, c) => s + c.booked, 0),
        Attended: t.classes.reduce((s, c) => s + c.attended, 0),
        Pay: `$${t.classes.reduce((s, c) => s + c.attended * (STAFF_MAP[t.teacher] ?? 0), 0).toFixed(2)}` });
    }
    exportXLSX("Payroll", rows, `iy-sp-payroll-${from}-${to}.xlsx`);
  };

  return (
    <div>
      <div className="adm-report-filters">
        <div className="adm-filter-group">
          <label className="adm-filter-label">From</label>
          <input type="date" className="adm-input" value={from} onChange={e => setFrom(e.target.value)} />
        </div>
        <div className="adm-filter-group">
          <label className="adm-filter-label">To</label>
          <input type="date" className="adm-input" value={to} max={today} onChange={e => setTo(e.target.value)} />
        </div>
      </div>
      {loading && <p className="adm-loading">Loading…</p>}
      {data && !loading && (
        <>
          <ExportBar onXLSX={doExport} />
          {(!data.teachers || data.teachers.length === 0)
            ? <p className="adm-empty">No classes in this period.</p>
            : data.teachers.map(t => {
                const rate          = STAFF_MAP[t.teacher] ?? 0;
                const totalAttended = t.classes.reduce((s, c) => s + c.attended, 0);
                const totalPay      = t.classes.reduce((s, c) => s + c.attended * rate, 0);
                return (
                  <div key={t.teacher} className="adm-report-teacher">
                    <div className="adm-report-teacher-header">
                      <span className="adm-report-teacher-name">{t.teacher}</span>
                      <span className="adm-report-teacher-rate">${rate}/student attended</span>
                    </div>
                    <table className="adm-report-table">
                      <thead><tr><th>Date</th><th>Class</th><th>Booked</th><th>Attended</th><th>Pay</th></tr></thead>
                      <tbody>
                        {t.classes.map((c, i) => (
                          <tr key={i}>
                            <td>{c.date}</td><td>{c.title}</td><td>{c.booked}</td>
                            <td><strong>{c.attended}</strong></td>
                            <td>{fmtMoney(c.attended * rate)}</td>
                          </tr>
                        ))}
                      </tbody>
                      <tfoot>
                        <tr className="adm-report-subtotal">
                          <td colSpan={3}>Subtotal</td>
                          <td><strong>{totalAttended}</strong></td>
                          <td>{fmtMoney(totalPay)}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                );
              })
          }
        </>
      )}
    </div>
  );
}